import text from '@bingads-webui-component-legacy/form/viewmodel/control/text';

export default function textarea(local, attrs, field, viewModel) {
  //Currently the same with text
  text(local, attrs, field, viewModel);
}
